import PrintTemplate from 'react-print'
import React, { Component } from 'react';
import ReactDOM from 'react-dom'
import DisplayDelivery from './DisplayDelivery'
import moment from 'moment'
import {formatPrice,formatQuantity} from '../helpers/helpers'

class PrintOrder extends Component{
    render() {   	

        return (
            <PrintTemplate>
            	<div className="wrapThis">
	            	<div className="salesReportWrapper">
	            		<div className="row topSaleHeader">
			            	<div className="printLogoArea pull-left">
			            		<img src="../../img/solapologo.jpg" />
			            	</div>

			            	<div id="poTop" className="contentReportSolapo pull-right">
								<h3>SOLAPO ROOFING CORPORATION</h3>
								<div className="row">
									<div className="col-1 pull-left">
										<p><strong>BACOLOD MAIN OFFICE:</strong></p>
										<p><span>3rd Road Burgos Ext.</span></p>
										<p><span>Brgy. Villamonte</span></p>
										<p><span>Bacolod City</span></p>
										<p><span>(034) 441-3860</span></p>
									</div>
									<div className="col-2 pull-left">
										<p><strong>CUSTOMER HOTLINE:</strong></p>
										<p><span>Smart: (0999) 994-6536</span></p>
										<p><span>Sun: (0932) 857-7356</span></p>
										<p><span>Globe (0917) 321-4945</span></p>
									</div>
									<div className="col-3 pull-left">
										<p><strong>EMAIL:</strong></p>
										<p><span>solaporoofingcenter@yahoo.com</span></p>
									</div>
								</div>
			            	</div>
			            	<div className="clearfix"></div>
		            	</div>
			            <h4 className="text-center"><strong>Purchase Order</strong></h4>
			            <div className="salesRange text-center">FOR QUOTATION {this.props.order.quoteNumber}</div>
			            <table id="forPurchaseOrder" className="table tablePrint">
			                <thead className="theadSalesReport">

			                </thead>
			                <tbody>		                   
	                            <tr>
	                                <td className="normalLetterSpacing text-uppercase">Customer Name : <span className="rvwQtData">{this.props.order.name}</span></td>
	                                <td className="normalLetterSpacing text-uppercase">Address : <span className="rvwQtData">{this.props.order.address}</span></td>
	                            </tr>
	                            <tr>
	                                <td className="normalLetterSpacing text-uppercase">Item: <span className="rvwQtData">{this.props.order.item}</span></td>
	                                <td className="normalLetterSpacing text-uppercase">Thickness : <span className="rvwQtData">0.{this.props.order.thickness}</span></td>
	                            </tr>
	                            <tr>
	                                <td className="normalLetterSpacing text-uppercase">Color : <span className="rvwQtData">{this.props.order.color}</span></td>
	                                <td className="normalLetterSpacing text-uppercase">Date : <span className="rvwQtData">{this.props.order.date}</span></td>
	                            </tr>
			                </tbody>
			            </table>
			            <hr/>
			            {
				            this.props.orderLm &&
				            <div className="marginTop10px">
					            <p className="nomargin">PANELS:</p>
					            <table id="normalLetterSpacing1" className="table tablePrint">
			                        <thead>
			                            <tr>
			                                <th>QUANTITY</th>
			                                <th>OF SHEETS</th>
			                                <th>LENGTH</th>
			                                <th>UNIT</th>
			                                <th>TOTAL LM</th>
			                            </tr>
			                         </thead>
			                         <tbody>
			                            {
			                                this.props.orderLm &&
			                                    Object.keys(this.props.orderLm).map(function (key){
			                                        let list = this.props.orderLm[key]

			                                        return(
			                                                <tr>
			                                                    <td>{formatQuantity(list.number)}</td>
			                                                    <td className="text-uppercase">Sheets</td>
			                                                    <td>{formatQuantity(list.length)}</td>
			                                                    <td>M</td>
			                                                    <td>{formatQuantity(list.total)}</td>
			                                                </tr>
			                                            )

			                                    }.bind(this))
			                            }
			                            <tr>
			                                <td></td>
			                                <td></td>
			                                <td></td>
			                                <td className="createBorderNoRight fontBoldOnly">Grand Total</td>
			                                <td className="createBorderNoLeft fontBoldOnly">{formatQuantity(this.props.order.totalLm)}</td>
			                            </tr>
			                         </tbody>   
			                    </table>
		                    </div>
	                	}
	                    {
	                    	this.props.orderSheets &&

	                    	<div className="marginTop10px">
		                    	<p className="nomargin">PLAINSHEETS:</p>
			                    <table id="normalLetterSpacing" className="table tablePrint">
			                        <thead>
			                            <tr>
			                                <th>QUANTITY</th>
			                                <th>OF SHEETS</th>
			                                <th>THICKNESS</th>
			                                <th>DIMENSION</th>
			                                <th>LENGTH</th>
			                                <th>COLOR</th>
			                            </tr>
			                        </thead>
			                      
			                               { this.props.orderSheets &&
			                                    Object.keys(this.props.orderSheets).map(function (key){
			                                        let list = this.props.orderSheets[key]

			                                        return(
			                                                <tr>
			                                                    <td>{formatQuantity(list.number)}</td>
			                                                    <td className="text-uppercase">Sheets</td>
			                                                    <td>0.{list.thickness}</td>
			                                                    <td>{list.dimension}</td>
			                                                    <td>{list.length}</td>
			                                                    <td className="text-uppercase">{list.color}</td>
			                                                </tr>
			                                            )

			                                    }.bind(this))
			                           		}
			                           
			                    </table>
		                    </div>
	                    }		            
		            </div>
	            </div>
			</PrintTemplate>
        );
    }
};

export default PrintOrder;


// WEBPACK FOOTER //
// ./src/components/PrintOrder.js